<template>
    <div>
        <delivery-lead-single-debug v-for="row in rows" :app_id="app_id" :delivery_lead_id="row.id" :key="row.id"></delivery-lead-single-debug>
    </div>
</template>

<script>
import DeliveryLeadSingleDebug from "./delivery-lead-single-debug";

export default {
    components: {DeliveryLeadSingleDebug},
    props: [
        'app_id'
    ],
    data() {
        return {
            rows: null
        };
    },
    methods: {
        refresh() {
            axios.get(url(`app/test/app/${this.app_id}/delivery`))
                .then((response) => {
                    this.rows = response.data.rows;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>